// extracted by mini-css-extract-plugin
module.exports = {"search__header":"withTopLocatorAndBottomNav_search__header__nJ5NX"};